import { rechargeApiRequest, getInternalSession } from '../utils/request.js';

async function getOnetime(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { onetime } = await rechargeApiRequest(
    "get",
    `/onetimes`,
    {
      id
    },
    getInternalSession(session, "getOnetime")
  );
  return onetime;
}
function listOnetimes(session, query) {
  return rechargeApiRequest(
    "get",
    `/onetimes`,
    { query },
    getInternalSession(session, "listOnetimes")
  );
}
async function createOnetime(session, createRequest) {
  const { onetime } = await rechargeApiRequest(
    "post",
    `/onetimes`,
    {
      data: createRequest
    },
    getInternalSession(session, "createOnetime")
  );
  return onetime;
}
async function updateOnetime(session, id, updateRequest) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  const { onetime } = await rechargeApiRequest(
    "put",
    `/onetimes`,
    {
      id,
      data: updateRequest
    },
    getInternalSession(session, "updateOnetime")
  );
  return onetime;
}
function deleteOnetime(session, id) {
  if (id === void 0 || id === "") {
    throw new Error("ID is required");
  }
  return rechargeApiRequest(
    "delete",
    `/onetimes`,
    {
      id
    },
    getInternalSession(session, "deleteOnetime")
  );
}

export { createOnetime, deleteOnetime, getOnetime, listOnetimes, updateOnetime };
//# sourceMappingURL=onetime.js.map
